import { scrollAnimation } from './function/scroll-animation.js';
const tile = require('./function/tile.js');
const slick = require('/assets/js/slick/slick.js');
import '/assets/js/common.js';
import '/assets/js/slick/slick.css';
import '/assets/css/_common.scss';
import '/assets/css/food-consulting.scss';


// ===========================================
// モーダルのインタラクション
// ===========================================
$(function () {
  $('.pointList').each(function(n){
    const item = $(this).find('.pointList__item'),
          modal = $('.pointModal'),
          boxInner = modal.find('.pointModal__boxInner'),
          shadow = modal.find('.pointModalShadow'),
          close = modal.find('.close');

    let img,
        ttl,
        txt;

    item.on('click', function(){
      img = $(this).attr('data-img');
      ttl = $(this).attr('data-ttl');
      txt = $(this).attr('data-txt');

      boxInner.html('');

      if( img ) {
        boxInner.append('<img src="' + img + '">');
      }

      if( ttl ) {
        boxInner.append('<h3>' + ttl + '</h3>');
      }

      if( txt ) {
        boxInner.append('<p>' + txt + '</p>');
      }

      modal.addClass('on');
      $('html').css({ overflow: 'hidden' });
    });

    shadow.on('click', function(){
      modal.removeClass('on');
      $('html').css({ overflow: 'auto' });
    });

    close.on('click', function(){
      shadow.click();
    });
  });
});